import { SuccessResponse } from '@back-office/http';
import { Instance } from 'mobx-state-tree';
import { ResponseMessage } from '../constants';
import AlertModel from '../stores/alert.store';
import AuthModel from '../stores/auth.store';
import CancelReasonTypesModel from '../stores/cancel-reason-types.store';
import InvitationModel from '../stores/invitations.store';
import InvoicesModel from '../stores/invoice.store';
import OTPModel from '../stores/opt.store';
import PermissionsTypeModel from '../stores/permissions.store';
import RecurringDetailModel from '../stores/recurring-detail.store';
import RecurringFileModel from '../stores/recurring-file.store';
import RecurringRequestModel from '../stores/recurring-request.store';
import RecurringTransactionModel from '../stores/recurring-transaction.store';
import RejectReasonTypesModel from '../stores/reject-reason-types.store';
import RefundRequestTypesModel from '../stores/request.store';
import TransactionDetail from '../stores/transaction.store';
import TransactionModel from '../stores/transactions.store';
import UsersModel from '../stores/users.store';

export interface Self {
  isLoading: boolean;
  invoice: Instance<typeof InvoicesModel>;
  alert: Instance<typeof AlertModel>;
  auth: Instance<typeof AuthModel>;
  transaction: Instance<typeof TransactionModel>;
  detail: Instance<typeof TransactionDetail>;
  invitations: Instance<typeof InvitationModel>;
  users: Instance<typeof UsersModel>;
  otp: Instance<typeof OTPModel>;
  stage: string;
  isProgress: boolean;
  loginStep: string;
  requestTypes: Instance<typeof RefundRequestTypesModel>;
  permissionsList: Instance<typeof PermissionsTypeModel>;
  recurringRequest: Instance<typeof RecurringRequestModel>;
  recurringDetail: Instance<typeof RecurringDetailModel>;
  recurringFile: Instance<typeof RecurringFileModel>;
  rejectReasonTypes: Instance<typeof RejectReasonTypesModel>;
  cancelReasonTypes: Instance<typeof CancelReasonTypesModel>;
  recurringTransaction: Instance<typeof RecurringTransactionModel>;
  clearSession: () => void;
}

export function handleNotAuthorized(
  self: Self,
  response: SuccessResponse
): ResponseMessage.OK {
  const { status } = response.data;
  self.alert.title = status.messages[0];
  self.alert.open = true;
  self.alert.handleOK = () => {
    self.clearSession();
  };
  return ResponseMessage.OK;
}

export function handleSuccess(
  self: Self,
  response: SuccessResponse
): ResponseMessage.OK {
  const { status } = response.data;
  if (status.code === 1000) {
    return ResponseMessage.OK;
  }
  if (status.code === 9500) {
    return handleNotAuthorized(self, response);
  }
  self.alert.title = status.messages[0];
  self.alert.open = true;
  throw new Error(ResponseMessage.Error);
}

export function handleApiLimitExceeded(self: Self): ResponseMessage.OK {
  self.alert.title = 'Password reset blocked';
  self.alert.message = 'Too many attempts, please try again later.';
  self.alert.open = true;
  self.alert.handleOK = () => {
    self.clearSession();
  };
  return ResponseMessage.OK;
}

export function handleErrorVoidRefund(self: Self): ResponseMessage.OK {
  self.alert.title = 'Something went wrong';
  self.alert.message =
    'We are unable to process your request at this time. Please try again later.';
  self.alert.open = true;
  return ResponseMessage.OK;
}
